import React, { useState } from 'react';

import { Collapse, Grid, IconButton, Paper, Typography } from '@mui/material';
import { AnimatedArrowIcon } from 'src/components/generic';
import { makeStyles } from 'tss-react/mui';

import { NumberBadge } from './NumberBadge';

const useStyles = makeStyles()(theme => ({
  cardBody: {
    padding: theme.spacing(2, 4, 4, 4),
  },
  cardHeader: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
  cardTitle: {
    alignItems: 'baseline',
    display: 'flex',
    gap: theme.spacing(1.5),
  },
  stepCard: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    // Ensures card doesn't grow past content height...
    height: 'fit-content',
    width: 800,
  },
}));

interface StepLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  n: number;
  title: string;
}

export function StepLayout({ children, n, title }: StepLayoutProps): JSX.Element {
  const { classes } = useStyles();
  const [expanded, setExpanded] = useState<boolean>(true);

  return (
    <Paper className={classes.stepCard}>
      <Grid
        container
        className={classes.cardHeader}
        sx={{
          alignItems: 'center',
        }}
      >
        <div className={classes.cardTitle}>
          <NumberBadge n={n} />
          <Typography variant="h1">{title}</Typography>
        </div>
        <IconButton size="large" onClick={(): void => setExpanded(!expanded)}>
          <AnimatedArrowIcon rotated={expanded} />
        </IconButton>
      </Grid>
      <Collapse in={expanded}>
        <div className={classes.cardBody}>{children}</div>
      </Collapse>
    </Paper>
  );
}
